import { customTextBlock, paragraph, heading } from "../../../text/nodes"
import { getFont } from "app/regions/blocks/shared/fonts"
import { TwoColumns as TwoColumnsEditor } from "./two-columns"
import { TwoColumnsSettings } from "./two-columns-settings"
import TwoColumnsPreview from "./two-columns-preview.png"

export const TwoColumns = {
  name: "TwoColumns",
  label: "two columns",
  EditorComponent: TwoColumnsEditor,
  SettingsComponent: TwoColumnsSettings,
  image: TwoColumnsPreview,
  defaultProperties: {
    backgroundColor: null,
    horizontalPadding: 0,
    verticalPadding: 0,
    marginTop: 24,
    marginBottom: 24,
    columnRatio: 50,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#2C2C2C",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    headingColor: "#2C2C2C",
    textColor: "#4D4D4D",
    headingFontFamily: getFont("Charter"),
    headingFontWeight: 700,
    textFontFamily: getFont("System Font"),
    textFontWeight: 400,
    verticalAlign: "top",
    gap: 20
  },
  defaultChildren: [
    customTextBlock([heading("one", "A great title that stands out!")]),
    customTextBlock([
      paragraph(
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc interdum, elit id molestie laoreet, arcu quam molestie orci, quis sollicitudin ipsum nibh nec est."
      ),
      paragraph(
        "Pellentesque dictum bibendum elit eu vulputate. Phasellus tristique, purus a lobortis tincidunt, tortor mi dapibus nulla, quis condimentum lorem nulla a mi. Nullam porttitor turpis nec tortor pharetra, a finibus risus sagittis."
      )
    ])
  ]
}
